export default function prettifyEnumString(string: string) {
  let prettifiedString = string.toLocaleLowerCase();
  prettifiedString = prettifiedString.replaceAll('_', ' ');

  return prettifiedString.charAt(0).toUpperCase() + prettifiedString.slice(1);
}
